import { BaseEntity } from '../../../../models';

export interface ClienteTipoPrazoPagamento {
    tipoPagamento: number;
    prazosPagamento: ClientePrazoPagamento[];
}

export class ClientePrazoPagamento implements BaseEntity {
    readonly id: number;
    idCliente: number;
    sequencia: number;
    prazo: number;
}
